import React from 'react';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { PaginationLinks, ListingCardByType } from '../../../components';

import css from './SearchResultsPanel.module.css';

// LISTING-CARD-01: migrated to the shared <UroboroxListingCard>.
// The inline UroboroxListingCard + SECTOR/PROVINCIA maps that
// lived here are now in the component so every consumer (Search,
// Landing carousel, Mis anuncios) shares the same layout.

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings = [],
    pagination,
    search,
    isMapVariant = true,
    // FASE2-BUSCADOR-3a: la paginación recibe el NOMBRE DE RUTA del feed, no su
    // tipo de anuncio. Antes lo deducía —`listingTypeParam ?
    // 'SearchPageWithListingType' : 'SearchPage'`— y construía la URL metiendo
    // el tipo como parámetro de ruta. Con un feed por ruta el tipo ya no está
    // en la URL, así que deducirlo sacaría al usuario del feed al pasar de
    // página. Quien renderiza el panel sabe en qué ruta está; se lo pasa.
    pageName = 'SearchPage',
    intl,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName={pageName}
        pageSearchParams={search}
        pagination={pagination}
        aria-label={intl.formatMessage({ id: 'SearchResultsPanel.screenreader.pagination' })}
      />
    ) : null;

  return (
    <div className={classes}>
      <ul className={css.listingCards}>
        {listings.map(l => (
          <li key={l.id.uuid} className={css.resultItem}>
            {/* FASE2-BUSCADOR-3b: cada tipo de anuncio tiene su tarjeta. La
                del mandato no es una variante de la de venta: leen campos
                distintos, y usar la de venta dejaba cinco celdas vacías. */}
            <ListingCardByType listing={l} variant="default" />
          </li>
        ))}
        {props.children}
      </ul>
      {paginationLinks}
    </div>
  );
};

export default SearchResultsPanel;
